export default {
  VisbyRoundMedium: "VisbyRoundCF-Medium",
  VisbyRoundLight: "VisbyRoundCF-Light"
};
